module.exports = function () {
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());

  // Set the gtag using the global variable myGtagId.
  gtag("config", window.myGtagId);
};
